<template>
  <div id="Index">
    <div class="inputFrame">
      <h2 style="text-align: center;margin: 20px 0;">中双协证书管理系统</h2>
      <Form ref="userForm" :model="userForm" :rules="ruleInline">
        <FormItem prop="account">
          <Input type="text" v-model="userForm.account" placeholder="管理员用户名">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="password">
          <Input type="password" v-model="userForm.password" placeholder="管理员密码">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem style="text-align: right;">
          <Button type="primary" @click="handleSubmitAction('userForm')">登录系统</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { adminLogin } from "@/request/login";

export default {
  name: "Index",
  data () {
    return {
      userForm: {
        account: '',
        password: ''
      },
      ruleInline: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入账号密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '密码不正确，请重新输入', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmitAction(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          adminLogin(this.userForm).then(res=> {
            if (res.data.error === 200) {
              let { token, admin_name } = res.data.data;
              // 保存token
              this.$store.commit('SET_TOKEN', token);
              // 设置用户名
              this.$store.commit('SET_ADMIN_NAME', admin_name);
              // 跳转到首页
              this.$router.push('/admin/ranks');
            } else {
              this.$Notice.error({
                title: '登录失败',
                desc: res.data.message
              })
            }
          })
        }
      })
    }
  },
  // 完成了 data 数据的初始化，el没有
  created () {}
}
</script>

<style scoped>
#Index {
  background-color: #e8eaec;
  position:absolute;
  top: 0;
  bottom:0;
  left:0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.inputFrame {
  width: 520px;
  height: 300px;
  border-radius: 5px;
  background-color: #f8f8f9;
  align-self: center;
  padding: 20px;
}
</style>
